<template src="./BTable.html"></template>

<script>

/*
 events: onSelect
 */
import BaseTable from '../../basicElement/table/BaseTable.vue'
export default {
  name: "fpBTable",
  data() {
    return {
      dataSource: [],
      fetch: false
    }
  },
  components: {
    BaseTable
  },
  props: {
    "cols": {
      type: Array,
      default: []
    },
    'selectType': {
      type: String
    },
    "singleSelectTypeIcon": {
      type: String,
      default: "fa fa-edit"
    },
    "singleSelectText": {
      type: String,
      default: ""
    },
    "api": {
      type: String
    },
    'filterDto': {
      type: Object,
      default: {}
    },
    "size": {
      type: String,
      default: "default"
    }
  },
  methods: {
    handleSelect(index, row) {
      this.$emit('onSelect', index, row);
    },

    handleSingleSelect(args) {
      this.$emit('onSingleSelect', args);
    },
    handleCommandSelect(args) {
      this.$emit('onCommandSelect', args);
    },
    refresh() {
      this.fetch = true;
      this.http.request(this.api, this.filterDto).then(data => {
        this.fetch = false;
        this.dataSource = data.items;
      });
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// BTable.vue?5844d9d8